const faqdata = {
  accordionItems: [
    {
      id: "question-1",
      header: "What is astrology and how does it work?",
      content:
        "Astrology is a Vedic science that studies the influence of planets and stars on human life. Your birth chart (kundli) is created based on the position of celestial bodies at the time of your birth, which helps in predicting life events and guiding important decisions.",
    },
    {
      id: "question-2",
      header: "What is a birth chart (kundli) and why is it important?",
      content:
        "A birth chart is prepared using your exact date, time, and place of birth. It helps analyze various aspects of life like career, marriage, health, finances, and more. It acts as a blueprint of your life path.",
    },
    {
      id: "question-3",
      header: " Do Vedic rituals and pujas really work?",
      content:
        "Yes, when performed correctly by qualified priests using authentic Vedic methods, pujas help balance planetary energies, remove negative influences, and invite positivity and peace into your life.",
    },
    {
      id: "question-4",
      header: " What types of pujas do you offer?",
      content:
        " We offer a wide range of rituals including Graha Shanti Puja, Mangal Dosh Nivaran, Kaal Sarp Dosh Puja, Vivah Badha Nivaran, Santan Gopal Puja, Lakshmi Puja, Ganesh Puja, Maha Mrityunjaya Jaap, and more.",
    },
    {
      id: "question-5",
      header: " Is online puja effective?",
      content:
        " Absolutely. Online pujas conducted via live video call by expert priests following Vedic procedures are just as effective as in-person rituals. We provide complete transparency and real-time participation.",
    },
    {
      id: "question-6",
      header: " How do I know which gemstone is right for me?",
      content:
        "  A gemstone should only be worn after a detailed analysis of your birth chart by a qualified astrologer. Each stone is linked to a specific planet and wearing the wrong one can have adverse effects.",
    },
    {
      id: "question-7",
      header: "  Are the gemstones you provide genuine and certified?",
      content:
        "Yes, we only offer 100% natural, lab-certified, and astrologically energized gemstones that are selected specifically according to your planetary needs.",
    },
    {
      id: "question-8",
      header: " Do gemstones show instant results?",
      content:
        "Gemstones work gradually by aligning your aura with planetary energies. The impact depends on your planetary positions and how consistently you wear the gemstone as per prescribed rituals.",
    },
    {
      id: "question-9",
      header: "   How can I get astrological consultation?",
      content:
        "You can book a consultation through our website by filling in your birth details. We offer personalized reports via phone, video call, or detailed PDF email format.",
    },
    {
      id: "question-10",
      header: " When will I receive my report or puja details?",
      content:
        " Astrological reports are usually delivered within 24–48 hours. For puja bookings, you’ll receive confirmation along with the date, time, and live Google Meet link well in advance.",
    },

  ],
};

export default faqdata;